import styled from "styled-components";
import { desktopWide } from "../../../atoms/MediaQueries";


export const ButtonWrapper = styled.div`
  display: flex;
  margin-left: auto;
  justify-content: center;
  flex-direction: column;
  p {
    margin-bottom: 8px;
  }
  @media (${desktopWide}) {
    flex-direction: row;
    p {
      margin-left: 8px;
      margin-bottom: 0;
    }
  }
`
